import React from "react";

function NoData(props) {
  return (
    <div className="bg-gray-400 w-11/12 mx-auto px-3 py-3 rounded-md">
      <p className="text-xl">Data Not Found</p>
    </div>
  );
}

export default NoData;
